import axios from 'axios';

/** Mismo valor que `TOKEN_KEY` en `authStore.js` */
const ACCESS_TOKEN_KEY = 'access_token';

let adminUnauthorizedRedirectPending = false;

const baseURL =
  import.meta.env.VITE_API_URL?.replace(/\/$/, '') ||
  (import.meta.env.DEV ? '/api' : '/api');

export const api = axios.create({
  baseURL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(ACCESS_TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error.response?.status;

    if (status === 401 && typeof window !== 'undefined') {
      const reqUrl = String(error.config?.url || '');
      const path = window.location.pathname;
      const isPublicAdminAuth =
        path === '/admin/login' ||
        path === '/admin/olvido-clave' ||
        path === '/admin/restablecer-clave';
      const onAdminApp = path.startsWith('/admin') && !isPublicAdminAuth;
      const isLoginRequest = reqUrl.includes('/auth/login');

      if (onAdminApp && !isLoginRequest && !adminUnauthorizedRedirectPending) {
        adminUnauthorizedRedirectPending = true;
        const data = error.response?.data;
        const fromApi =
          data && typeof data.message === 'string' && data.message.trim() !== ''
            ? data.message.trim()
            : '';
        const detail =
          fromApi !== ''
            ? fromApi
            : 'Tu sesión expiró o el token ya no es válido. Inicia sesión de nuevo.';
        try {
          sessionStorage.setItem(
            'admin_auth_notice',
            JSON.stringify({
              title: detail,
              text: 'Inicia sesión de nuevo para continuar en el panel administrativo.',
            })
          );
        } catch {
          /* ignore quota / private mode */
        }
        localStorage.removeItem(ACCESS_TOKEN_KEY);
        window.location.assign('/admin/login');
        return new Promise(() => {});
      }
    }

    const message =
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      'Error de conexión';

    const enriched = new Error(message);
    enriched.status = status;
    enriched.payload = error.response?.data;
    return Promise.reject(enriched);
  }
);

export default api;
